import { Node, ReactNodeViewRenderer } from "@tiptap/react";
import HTMLEditorButton from "./components/HtmlEditor";

export const HTMLEditorExtension = Node.create({
	name: "htmlEditor",
	group: "block",
	content: "block*",
	defining: true,
	draggable: false,

	parseHTML() {
		return [{ tag: 'div[data-type="htmlEditor"]' }];
	},

	renderHTML() {
		return ["div", { "data-type": "htmlEditor" }];
	},

	addCommands() {
		return {
			setHTMLEditor:
				() =>
					({ commands }) =>
						commands.insertContent(`<div data-type="htmlEditor"></div>`)
		};
	},

	addNodeView() {
		return ReactNodeViewRenderer(HTMLEditorButton);
	},

	addOptions() {
		return {
			button: ({ editor, extension, node }) => ({
				component: HTMLEditorButton,
				componentProps: {
					tooltip: "Source",
					editor: editor,
					setContent: extension.options.setContent
				}
			})
		};
	}
});
